import sortBy from 'lodash/sortBy';
import { getAllAssets, getAllAssetsV2, getAssetsLoadingStatusV2, getLoadingStatuses } from 'helpers/selectors';
import { createSelector } from 'reselect';
import { hasCapability } from './helpers';
import { NEWCAPABILITIES } from 'helpers/constants';
import { getAssetGroupOverviewList } from '../PowertrainConditionMonitoring/ConditionIndicesOverviewV2/AssetGroupOverview/selectors';
import { getAssetOverviewList } from '../PowertrainConditionMonitoring/ConditionIndicesOverviewV2/AssetOverview/selectors';
import { getPowertrainOverviewList } from '../PowertrainConditionMonitoring/ConditionIndicesOverviewV2/PowertrainOverview/selectors';
import { createErrorDataSelector } from 'selectors/selectorUtils';


const getReportsLoadingStatus = ({ reports }) => {
    return reports?.list?.loadingStatus;
};

const getReportError = ({ reports }) => {
    return {
        error: reports?.list?.error,
        errorCode: reports?.list?.error?.statusCode,
        loadingStatus: reports?.list?.loadingStatus
    };
};

// Memoized selector for default report error data
const getReportErrorData = createErrorDataSelector(getReportError);

const getSelectedOrganizations = ({ generalFilter }) => {
    return generalFilter.selectedFilters.organizations;
};

const getReportCapabilitiesLoadingStatus = ({ reports }) => {
    return reports?.reportCapabilities?.loadingStatus;
};

export const getReportCapabilities = ({ reports }) => {
    return reports?.reportCapabilities?.data;
};

const getReportsCapabilitiesError = ({ reports }) => {
    return {
        error: reports?.reportCapabilities?.error,
        errorCode: reports?.reportCapabilities?.error?.statusCode,
        loadingStatus: reports?.reportCapabilities?.loadingStatus
    };
};

// Memoized selector for default report capabilities error data
const getReportCapabilitiesErrorData = createErrorDataSelector(getReportsCapabilitiesError);

export const getAssetsWithExpertReportUpload = createSelector(
    [
        getAllAssetsV2,
        getReportCapabilities,
    ],
    (assets, reportCapabilities) => {
        return sortBy(assets.filter((asset) => {
            return hasCapability(asset.id, reportCapabilities, NEWCAPABILITIES.expertReportUpload);
        }), (o) => (o?.componentName || '').toLowerCase());
    }
);

export const getAssetsWithRegularReportUpload = createSelector(
    [
        getAllAssetsV2,
        getReportCapabilities,
    ],
    (assets, reportCapabilities) => {
        return sortBy(assets.filter((asset) => {
            return hasCapability(asset.id, reportCapabilities, NEWCAPABILITIES.regularReportUpload);
        }), (o) => (o?.componentName || '').toLowerCase());
    }
);

const getSensorOfAssetError = ({ reports }) => {
    return {
        error: reports?.sensorOfAssets?.error,
        errorCode: reports?.sensorOfAssets?.error?.statusCode,
        loadingStatus: reports?.sensorOfAssets?.loadingStatus
    };
};

// Memoized selector for default sensor of asset error data
const getSensorOfAssetErrorData = createErrorDataSelector(getSensorOfAssetError);

export const getModel = createSelector([
    getReportsLoadingStatus,
    getAssetsLoadingStatusV2,
    getLoadingStatuses,
    getReportCapabilitiesLoadingStatus,
    getSelectedOrganizations,
    getAllAssets,
    getAssetsWithExpertReportUpload,
    getAssetsWithRegularReportUpload,
    getAssetOverviewList,
    getPowertrainOverviewList,
    getAssetGroupOverviewList,
    getReportErrorData,
    getReportCapabilitiesErrorData,
    getSensorOfAssetErrorData
], (
    reportsLoadingStatus,
    assetsLoadingStatus,
    generalFilterLoadingStatuses,
    reportCapabilitiesLoadingStatus,
    organizations,
    assets,
    assetsWithExpertReportUpload,
    assetsWithRegularReportUpload,
    conditionIndicesV2AssetList,
    conditionIndicesV2PowerTrain,
    conditionIndicesV2AssetGroups,
    reportErrorData,
    reportCapabilitiesErrorData,
    sensorOfAssetErrorData
) => {
    return {
        reportsLoadingStatus,
        assetsLoadingStatus,
        generalFilterLoadingStatuses,
        reportCapabilitiesLoadingStatus,
        organizations,
        assets,
        assetsWithExpertReportUpload,
        assetsWithRegularReportUpload,
        conditionIndicesV2AssetList,
        conditionIndicesV2PowerTrain,
        conditionIndicesV2AssetGroups,
        reportErrorData,
        reportCapabilitiesErrorData,
        sensorOfAssetErrorData
    };
});
